export default __webpack_public_path__ + "static/media/homepage.324d3131.mp4";